import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Formik } from 'formik';
import { useState } from 'react';
import clsx from 'clsx';
import * as Yup from 'yup';
import { errorMessages, inputValidationRegex } from '../../utils/common';
import Alert from '../Alert/Alert';
import Button from '../Button/Button';
import Modal from '../Modal/Modal';
import TextField from '../TextField/TextField';
import useStyles from './PrivacySettingsEmailForm.styles';
const validationSchema = Yup.object().shape({
    email: Yup.string()
        .trim()
        .required(errorMessages().required)
        .email()
        .matches(inputValidationRegex, errorMessages().unsupportedCharacters),
});
const initialValues = {
    email: '',
};
const PrivacySettingsEmailForm = (props) => {
    const { onSubmit } = props;
    const { classes } = useStyles();
    const [errorMessage, setErrorMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const formikConfig = {
        initialValues,
        enableReinitialize: true,
        validationSchema,
        onSubmit: (values) => onSubmit(values)
            .then(() => {
            setErrorMessage('');
            setShowModal(true);
        })
            .catch((error) => {
            setErrorMessage(error.message);
        }),
    };
    return (_jsx(Formik, Object.assign({}, formikConfig, { children: ({ isSubmitting }) => (_jsx(Form, { children: _jsxs("div", { className: classes.container, children: [errorMessage && _jsx(Alert, { className: classes.error, type: "alertError", message: errorMessage }), _jsx("div", { className: classes.input, children: _jsx(TextField, { name: "email", label: "Email address", placeholder: "e.g. rose.thorne@emailaddress.com", fullWidth: true, required: true }) }), _jsx("div", { className: classes.buttons, children: _jsx(Button, { variant: "secondary", fullWidth: true, thin: true, title: "Submit", isSubmit: true, disabled: isSubmitting }) }), showModal && (_jsx(Modal, { open: showModal, className: classes.modal, fullScreen: false, onClose: () => setShowModal(false), setOpen: () => setShowModal(true), title: "Changing Your Privacy Settings", children: _jsxs("div", { className: clsx(classes.innerContainer), children: [_jsx("p", { children: "An email has been sent and should arrive shortly. Simply click on the link in the email to change your personal settings." }), _jsx("p", { children: "If you don\u2019t receive an email, please check your spam folder or make sure you entered the correct email address." }), _jsx(Button, { variant: "primary", fullWidth: true, thin: true, title: "OK", onClick: () => setShowModal(false) })] }) }))] }) })) })));
};
export default PrivacySettingsEmailForm;
